"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TimeItem = _interopRequireDefault(require("./_TimeItem"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _time = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/time.css") : void 0);

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _time.default);
/** A **Time** component is used for a single time value. Multiple components can be used in the **Time Picker**
to assemble a clock time. A max of four will account for hours, minutes, seconds and meridiem of the day.
It is rarely used on its own as a standalone component. */

var Time = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Time, _Component);

  var _super = _createSuper(Time);

  function Time(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Time);
    _this = _super.call(this, props);

    _this.formatValue = function (value, name) {
      if (name !== 'meridiem' && (0, _parseInt2.default)(value, 10) < 10) {
        //using parseInt here to remove the zeroes before concatenating one
        value = '0'.concat((0, _parseInt2.default)(value, 10));
      }

      return value;
    };

    _this.updateTime = function (value, name) {
      _this.state.time[name] = value;

      _this.setState(function (prevState) {
        return _objectSpread({}, prevState.time);
      });

      _this.props.onChange(_this.state.time);
    };

    _this.updateActiveColumn = function (activeColumn) {
      var newActiveColumn = _this.state.active === 'meridiem' ? '' : activeColumn;

      _this.setState({
        active: newActiveColumn
      });
    };

    _this.CLOCK = [_this.props.localizedText.meridiemAM, _this.props.localizedText.meridiemPM];
    var _this$props = _this.props,
        time = _this$props.time,
        showHour = _this$props.showHour,
        showMinute = _this$props.showMinute,
        showSecond = _this$props.showSecond;

    if (time.hour === '00') {
      time.hour = _this.props.format12Hours ? '12' : '00';
    }

    var active;

    if (showHour) {
      active = 'hour';
    } else if (showMinute) {
      active = 'minute';
    } else if (showSecond) {
      active = 'second';
    } else {
      active = 'meridiem';
    }

    _this.state = {
      time: {
        hour: time.hour,
        minute: time.minute,
        second: time.second,
        meridiem: time.meridiem
      },
      format12Hours: props.format12Hours,
      active: active
    };
    return _this;
  }

  (0, _createClass2.default)(Time, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // check if props are different than the current state to prevent an unneeded render
      if (nextProps.time !== this.state.time) {
        this.setState({
          time: nextProps.time
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          cssNamespace = _this$props2.cssNamespace,
          localizedText = _this$props2.localizedText,
          showHour = _this$props2.showHour,
          showMinute = _this$props2.showMinute,
          showSecond = _this$props2.showSecond,
          format12Hours = _this$props2.format12Hours,
          id = _this$props2.id,
          disabled = _this$props2.disabled,
          onChange = _this$props2.onChange,
          timeProp = _this$props2.time,
          hoursUpButtonProps = _this$props2.hoursUpButtonProps,
          hoursDownButtonProps = _this$props2.hoursDownButtonProps,
          hoursInputProps = _this$props2.hoursInputProps,
          minutesUpButtonProps = _this$props2.minutesUpButtonProps,
          minutesDownButtonProps = _this$props2.minutesDownButtonProps,
          minutesInputProps = _this$props2.minutesInputProps,
          secondsUpButtonProps = _this$props2.secondsUpButtonProps,
          secondsDownButtonProps = _this$props2.secondsDownButtonProps,
          secondsInputProps = _this$props2.secondsInputProps,
          meridiemUpButtonProps = _this$props2.meridiemUpButtonProps,
          meridiemDownButtonProps = _this$props2.meridiemDownButtonProps,
          meridiemInputProps = _this$props2.meridiemInputProps,
          props = (0, _objectWithoutProperties2.default)(_this$props2, ["cssNamespace", "localizedText", "showHour", "showMinute", "showSecond", "format12Hours", "id", "disabled", "onChange", "time", "hoursUpButtonProps", "hoursDownButtonProps", "hoursInputProps", "minutesUpButtonProps", "minutesDownButtonProps", "minutesInputProps", "secondsUpButtonProps", "secondsDownButtonProps", "secondsInputProps", "meridiemUpButtonProps", "meridiemDownButtonProps", "meridiemInputProps"]);
      var _this$state = this.state,
          time = _this$state.time,
          active = _this$state.active;
      var max;

      if (format12Hours) {
        max = 12;
      } else {
        max = 24;
      }

      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
        className: classnames("".concat(cssNamespace, "-time")),
        id: id
      }), showHour ? /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-time__col")),
        onClick: function onClick() {
          return _this2.updateActiveColumn('hour');
        }
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: classnames("".concat(cssNamespace, "-time__slider-label"))
      }, localizedText.hoursLabel), /*#__PURE__*/_react.default.createElement(_TimeItem.default, {
        active: active,
        defaultValue: 1,
        disabled: disabled,
        downButtonProps: hoursDownButtonProps,
        format12Hours: format12Hours,
        inputProps: hoursInputProps,
        localizedText: {
          buttonUp: localizedText.hoursUp,
          buttonDown: localizedText.hoursDown
        },
        max: max,
        name: "hour",
        time: time,
        upButtonProps: hoursUpButtonProps,
        updateTime: this.updateTime,
        value: time.hour
      })) : '', showMinute ? /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-time__col")),
        onClick: function onClick() {
          return _this2.updateActiveColumn('minute');
        }
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: classnames("".concat(cssNamespace, "-time__slider-label"))
      }, localizedText.minutesLabel), /*#__PURE__*/_react.default.createElement(_TimeItem.default, {
        active: active,
        defaultValue: 1,
        disabled: disabled,
        downButtonProps: minutesDownButtonProps,
        format12Hours: format12Hours,
        inputProps: minutesInputProps,
        localizedText: {
          buttonUp: localizedText.minutesUp,
          buttonDown: localizedText.minutesDown
        },
        max: '60',
        name: "minute",
        time: time,
        upButtonProps: minutesUpButtonProps,
        updateTime: this.updateTime,
        value: time.minute
      })) : '', showSecond ? /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-time__col")),
        onClick: function onClick() {
          return _this2.updateActiveColumn('second');
        }
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: classnames("".concat(cssNamespace, "-time__slider-label"))
      }, localizedText.secondsLabel), /*#__PURE__*/_react.default.createElement(_TimeItem.default, {
        active: active,
        defaultValue: 1,
        disabled: disabled,
        downButtonProps: secondsDownButtonProps,
        format12Hours: format12Hours,
        inputProps: secondsInputProps,
        localizedText: {
          buttonUp: localizedText.secondsUp,
          buttonDown: localizedText.secondsDown
        },
        max: '60',
        name: "second",
        time: time,
        upButtonProps: secondsUpButtonProps,
        updateTime: this.updateTime,
        value: time.second
      })) : '', format12Hours ? /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(cssNamespace, "-time__col"))
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: classnames("".concat(cssNamespace, "-time__slider-label"))
      }, localizedText.meridiemLabel), /*#__PURE__*/_react.default.createElement(_TimeItem.default, {
        active: active,
        disabled: disabled,
        downButtonProps: meridiemDownButtonProps,
        inputProps: meridiemInputProps,
        localizedText: {
          buttonUp: localizedText.meridiemUp,
          buttonDown: localizedText.meridiemDown,
          meridiemAM: localizedText.meridiemAM,
          meridiemPM: localizedText.meridiemPM
        },
        max: '1',
        name: "meridiem",
        onCollapsedClick: function onCollapsedClick() {
          return _this2.updateActiveColumn('meridiem');
        },
        time: this.state.time,
        upButtonProps: meridiemUpButtonProps,
        updateActiveColumn: this.updateActiveColumn,
        updateTime: this.updateTime,
        value: this.CLOCK[this.state.time.meridiem]
      })) : '');
    }
  }]);
  return Time;
}(_react.Component);

Time.displayName = 'Time';
process.env.NODE_ENV !== "production" ? Time.propTypes = {
  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,

  /** Set to **true** to use the 12-hour clock (hours ranging from 01 to 12) and to display a meridiem control */
  format12Hours: _propTypes.default.bool,

  /** Additional props to be spread to the hours down `<button>` element */
  hoursDownButtonProps: _propTypes.default.object,

  /** Additional props to be spread to the hours `<input>` element */
  hoursInputProps: _propTypes.default.object,

  /** Additional props to be spread to the hours up `<button>` element */
  hoursUpButtonProps: _propTypes.default.object,

  /** Value for the `id` attribute on the element */
  id: _propTypes.default.string,

  /** Localized text to be updated based on location/language */
  localizedText: _CustomPropTypes.default.i18n({
    /** Ante meridiem for 12 hour clock */
    meridiemAM: _propTypes.default.string,

    /** Post meridiem for 12 hour clock */
    meridiemPM: _propTypes.default.string,
    hoursLabel: _propTypes.default.string,
    minutesLabel: _propTypes.default.string,
    secondsLabel: _propTypes.default.string,
    meridiemLabel: _propTypes.default.string,
    hoursUp: _propTypes.default.string,
    hoursDown: _propTypes.default.string,
    minutesUp: _propTypes.default.string,
    minutesDown: _propTypes.default.string,
    secondsUp: _propTypes.default.string,
    secondsDown: _propTypes.default.string,
    meridiemUp: _propTypes.default.string,
    meridiemDown: _propTypes.default.string
  }),

  /** Additional props to be spread to the meridiem down `<button>` element */
  meridiemDownButtonProps: _propTypes.default.object,

  /** Additional props to be spread to the meridiem `<input>` element */
  meridiemInputProps: _propTypes.default.object,

  /** Additional props to be spread to the meridiem up `<button>` element */
  meridiemUpButtonProps: _propTypes.default.object,

  /** Additional props to be spread to the minutes down `<button>` element */
  minutesDownButtonProps: _propTypes.default.object,

  /** Additional props to be spread to the minutes `<input>` element */
  minutesInputProps: _propTypes.default.object,

  /** Additional props to be spread to the minutes up `<button>` element */
  minutesUpButtonProps: _propTypes.default.object,
  name: _propTypes.default.string,

  /** Additional props to be spread to the seconds down `<button>` element */
  secondsDownButtonProps: _propTypes.default.object,

  /** Additional props to be spread to the seconds `<input>` element */
  secondsInputProps: _propTypes.default.object,

  /** Additional props to be spread to the seconds up `<button>` element */
  secondsUpButtonProps: _propTypes.default.object,

  /** Enables the input for hours */
  showHour: _propTypes.default.bool,

  /** Enables the input for minutes */
  showMinute: _propTypes.default.bool,

  /** Enables the input for seconds */
  showSecond: _propTypes.default.bool,

  /** Set to **true** to show up/down buttons for each input */

  /** The time component values. Contains four properties: **hour** (with values from 01 to 12 when `format12Hours`
    * is true or 00 to 23 when `format12Hours` is false), **minute** (with values from 00 to 59), **second** (with values from 00 to 59),
    * **meridiem** (with values 0 for AM or 1 for PM) */
  time: _propTypes.default.object,

  /**
   * Callback function; triggered when the current time is changed by user interaction.
   *
   * @param {Object} time - has hour, meridiem, minute, second properties as numbers
   * @returns {void}
   * */
  onChange: _propTypes.default.func
} : void 0;
Time.defaultProps = {
  localizedText: {
    meridiemAM: 'am',
    meridiemPM: 'pm',
    hoursLabel: 'Hours',
    minutesLabel: 'Minutes',
    secondsLabel: 'Seconds',
    meridiemLabel: 'AM/PM',
    hoursUp: 'Increase hours',
    hoursDown: 'Decrease hours',
    minutesUp: 'Increase minutes',
    minutesDown: 'Decrease hours',
    secondsUp: 'Increase seconds',
    secondsDown: 'Decrease seconds',
    meridiemUp: 'Increase period',
    meridiemDown: 'Decrease period'
  },
  onChange: function onChange() {},
  showHour: true,
  showMinute: true,
  showSecond: true,
  time: {
    hour: '00',
    minute: '00',
    second: '00',
    meridiem: 0
  }
};

var _default = (0, _withStyles.default)(Time);

exports.default = _default;